var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`group-116`, _vm.className || ``]},[_c('group111',{attrs:{"src":_vm.group111Props.src,"className":_vm.group111Props.className}}),_c('div',{staticClass:"ation-automatique textcourantsmall"},[_vm._v(_vm._s(_vm.confirmationAutomatique))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }